<template>
  <div class="ty-main">
    <div class="ty-cont">
      <el-form :inline="true" class="query-form" onsubmit="return false;">
        <el-form-item label="敏感词:">
          <el-input
            v-model="keyword"
            placeholder="输入敏感词进行搜索"
            clearable
            style="width: 202px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <div class="fr hidden" v-auth="['wordAdd']">
          <el-button class="dsfdi" type="primary" @click="openDialog">添加</el-button>
        </div>
      </el-form>
    </div>
    <div class="ty-content white">
      <el-table :data="tableData" style="width: 100%" stripe>
        <el-table-column prop="name" label="敏感词" fixed width="250">
          <template slot-scope="scope">
          <span>{{scope.row.name ? scope.row.name : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="匹配规则" width="450">
          <template slot-scope="scope">
            <div class="okm">{{scope.row.associative_words ? scope.row.associative_words : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="180">
          <template slot-scope="scope">
            <span>{{scope.row.created_at ? scope.row.created_at : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" min-width="180">
          <template slot-scope="scope">
            <span>{{scope.row.updated_at ? scope.row.updated_at : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="hidden"
              @click="handleEdit(scope.row)"
              v-auth="['wordEdit']"
            >
              编辑</el-button
            >
            <el-divider v-if= "on_line===2" direction="vertical" ></el-divider>
            <el-button
              type="text"
              class="hidden"
              @click="handleDelete(scope.row.id)"
              v-auth="['wordDel']"
            >
              删除</el-button
            >
          </template>
        </el-table-column>
        <template #empty>
          <el-empty v-loading="loading"></el-empty>
        </template>
      </el-table>

      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

      <el-dialog
      :title="title"
      :visible.sync="isRoleEdit"
      :append-to-body="true"
      :lock-scroll="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="622px">
        <el-tooltip class="iren" content="匹配规则需要设置单个汉字或两个字母及以上才能被审计到审计到" placement="top-start">
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-form
          class="dialog-form"
          :model="keywordForm"
          :rules="rules"
          label-width="100px"
          ref="keywordForm"
          v-if="isRoleEdit"
          @submit.native.prevent
        >
          <el-form-item label="敏感词:" prop="name" style="margin-bottom: 20px;">
            <el-input placeholder="请输入敏感词" clearable style="width: 424px;" v-model="keywordForm.name" :disabled="!!keywordForm.id" maxlength="15" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="匹配规则:" prop="content">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4.8, maxRows: 4.8}"
              clearable
              v-model="keywordForm.content"
              style="width: 424px;"
              placeholder="多个词语之间用逗号分隔"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" plain @click="isRoleEdit = false">取消</el-button>
          <el-button style="width: 72px;" type="primary" @click="addWord('keywordForm')">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog
      title="删除敏感词"
      :visible.sync="dialog03"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="20%">
      <span>此操作将清除该敏感词的相关风险统计，是否继续？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="cancel03">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="affirm03">确定</el-button>
      </span>
       <div class="ewqoij">
        <img class="img" src="../../assets/images/prompt.png" width=".875rem" height=".875rem">
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      keyword: '',
      dialog03: false,
      isRoleEdit: false,
      keywordForm: {},
      permissionList: [],
      tableData: [],
      loading: false,
      total: 0,
      on_line: 0,
      title: '',
      id: '',
      rules: {
        name: [{ required: true, message: '请输入敏感词，敏感词不能重复设置！', trigger: 'blur' }],
        content: [{ required: true, message: '请输入匹配规则', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$api
        .get('api/system/key/word/index', {
          name: this.keyword,
          page: this.currentPage
        })
        .then(res => {
          this.total = res.total
          this.on_line = res.line
          this.tableData = res.data
          this.loading = false
        })
    },
    handleEdit(row) {
      this.title = '编辑敏感词'
      this.keywordForm = {
        id: row.id,
        name: row.name,
        content: row.associative_words
      }
      this.isRoleEdit = true
    },
    detale(id) {
      this.dialog03 = true
      this.id = id
    },
    cancel03() {
      this.dialog03 = false
      this.$message.info('已取消删除！')
    },
    affirm03() {
      this.handleDelete()
      this.dialog03 = false
    },
    handleDelete(id) {
      this.$confirm('此操作将清除该敏感词的相关风险统计, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
      .then(() => {
        this.$api
          .post('/api/system/key/word/edit/delete', {
            key_id: id
          })
          .then(() => {
            this.getList()
            this.$message.success('删除成功！')
          })
      })
      .catch(() => {
        // this.$message.info('已取消删除！')
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    addWord(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 过滤空格和多余逗号
          // let content = this.keywordForm.content.replace(/\s*/g, '').replace(/,/g, '，')
          // content = content.split('，').filter(v => {
          //   return v !== ''
          // })
          if (/^[a-zA-Z]*$/.test(this.keywordForm.content) || /^\d+(\.\d+)?$/.test(this.keywordForm.content)) {
            if (this.keywordForm.content.length === 1) {
              this.$message({
                message: '匹配规则需要设置单个汉字或两个字符及以上才能被审计到',
                type: 'warning'
              })
              return false
            }
          }
          const params = {
            key_name: this.keywordForm.name,
            // key_data: content.join('，')
            key_data: this.keywordForm.content
          }
          this.keywordForm.id && (params.key_id = this.keywordForm.id)
          if (this.keywordForm.id) {
            this.$api.post('/api/system/key/word/edit', params).then(() => {
              this.isRoleEdit = false
              this.$message.success('修改成功')
              this.getList()
            })
          } else {
            this.$api.post('api/system/key/word/add', params).then(() => {
              this.isRoleEdit = false
              this.$message.success('添加成功！')
              this.getList()
            })
          }
        }
      })
    },
    openDialog() {
      this.keywordForm = {}
      this.title = '添加敏感词'
      this.isRoleEdit = true
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.iren{
  position: absolute;
  top: 23px;
  left: 125px;
}
::v-deep .el-dialog__title{
  color: #204a9e;
}
::v-deep .el-dialog__body {
  padding-top: 30px;
  padding-bottom: 40px;
  padding-left: 30px;
  padding-right: 30px;
}
::v-deep .el-form-item__label{
  margin-bottom: 0;
}
::v-deep .el-dialog__close{
  display: none;
}
.ewqoij{
  position: absolute;
  top: 1.4375rem;
  left: 1.875rem;
  width: .875rem;
  height: .875rem;
  .img {
    width: .875rem;
    height: .875rem;
  }
}
.okm {
  display: -webkit-box;
  overflow: hidden;
  white-space: pre-wrap;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
</style>
